export function liveChat() {
    (function() {
        $(document).ready(function () {
            $(".live-chat").on('click', function(e) {
                e.preventDefault();
                launchLiveChat();
            });
            $(".live-chat-mortgage").on('click', function(e) {
                e.preventDefault();
                launchLiveChatMortgage();
            });
            $(".live-chat-mortgage-sc").on('click', function(e) {
                e.preventDefault();
                launchLiveChatMortgageSC();
            });
        });

        function launchLiveChat() {
            window.open('https://vue.comm100.com/ChatWindow.aspx?siteId=3000074&planId=357',
                '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        }

        function launchLiveChatMortgage() {
            window.open('https://vue.comm100.com/ChatWindow.aspx?siteId=3000074&planId=356',
                '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        }

        function launchLiveChatMortgageSC() {
            window.open('https://vue.comm100.com/ChatWindow.aspx?siteId=3000074&planId=358',
                '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        }

    })();
}